import Animated, { type SharedValue, useAnimatedStyle } from "@-/com.npmjs.react-native-reanimated";
import type { ReactNode } from "react";
import { useChinaMapSheetSlideDistance } from "#use-china-map-sheet-slide-distance";

/**
 * Everything at the bottom of the map: the sheet and the buttons riding it. It comes up from below
 * the screen as the cards leave for the map, and goes back down as they return, on Learn's
 * transition `progress`. The sheet keeps its own layout and drag; only this layer moves.
 *
 * The sheet and its buttons ride in separate layers on the same clock (the page stacks them on
 * either side of its toolbar), so each passes its own `className` and `testID`.
 */
export function ChinaMapSheetSlide({
  children,
  className = "",
  progress,
  testID,
}: {
  children: ReactNode;
  className?: string;
  /** 0 with the cards on screen, 1 with the map. */
  progress: SharedValue<number>;
  testID: string;
}) {
  const distance = useChinaMapSheetSlideDistance();
  const slideStyle = useAnimatedStyle(() => ({
    transform: [{ translateY: (1 - progress.get()) * distance }],
  }));
  return (
    <Animated.View
      className={`absolute inset-0 ${className}`}
      pointerEvents="box-none"
      style={slideStyle}
      testID={testID}
    >
      {children}
    </Animated.View>
  );
}
